// extracted by mini-css-extract-plugin
export var fullWidthButton = "_gz-0";